import { injectIntl } from 'react-intl';
import SearchInput from './SearchInput';
export default injectIntl(SearchInput);
//# sourceMappingURL=SearchInput.container.js.map